import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Container, Icon } from 'semantic-ui-react';
import store from '../../../store';
import './warehouse.admin.scss';

function AdminWarehouseComponent(props: any) {
    const history = useHistory();
    const id = props.match.params.id;

    const [warehouse, setWarehouse] = useState<{ id: number | null; name: string; count: number; minCount: number; slug: string } | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (!token || token === 'undefined') {
            store.dispatch({ type: 'redirectUrl', data: window.location.pathname });
            history.push('/');
            return;
        }
        fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse/' + id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                Authorization: token,
                'Content-Type': 'application/json',
            },
        })
            .then((res) => {
                if (res.ok) return res.json();
                throw new Error('Failed to load');
            })
            .then((data) => {
                if (data?.warehouse) setWarehouse(data.warehouse);
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, [id, history]);

    const backUrl = props.location?.search?.includes('from=products') ? '/mongol/products' : undefined;

    if (loading || !warehouse) {
        return (
            <div className="page-admin">
                <Container>
                    <p>Ачааллаж байна...</p>
                </Container>
            </div>
        );
    }

    return (
        <div className="form-group">
            <div className="width-100">
                <section className="admin-warehouse-form warehouse-main-only">
                    <div className="margin-top-20">
                        <a onClick={() => history.push(backUrl || '/mongol/products')}>
                            <Icon name="arrow left" />
                            <span className="underline">Буцах</span>
                        </a>
                    </div>
                    <div className="margin-top-20">
                        <Link className="underline" to={'/mongol/warehouse-actions/' + warehouse.id}>
                            Үлдэгдлийн түүх
                        </Link>
                    </div>
                    <div className="margin-top-20">
                        <Link className="underline" to={'/mongol/warehouse/' + warehouse.id + '/imports'}>
                            Өртгийн жагсаалт
                        </Link>
                    </div>
                    <div className="margin-top-20">
                        <a className="underline" href={'/product/' + warehouse.slug} target="_blank" rel="noopener noreferrer">
                            Худалдааны линк
                        </a>
                        <h2>{warehouse.name}</h2>
                    </div>
                    <div className="warehouse-count-only">
                        <div className="label">Үлдэгдэл</div>
                        <div className="count-value">{warehouse.count}</div>
                        <div className="min-count">Анхааруулах үлдэгдэл: {warehouse.minCount}</div>
                    </div>
                    <div className="warehouse-actions-buttons">
                        <Button as={Link} to={'/mongol/warehouse/' + id + '/add'} color="green" size="large">
                            Үлдэгдэл нэмэх
                        </Button>
                        <Button as={Link} to={'/mongol/warehouse/' + id + '/minus'} color="red" size="large">
                            Үлдэгдэл хасах
                        </Button>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default AdminWarehouseComponent;
